<template>
  <div class="input-group quantity-selector">
    <button
      class="btn btn-outline-secondary border z-1 btn-lg"
      type="button"
      @click="handleSubtract"
    >
      <font-awesome-icon icon="fa-solid fa-minus" />
    </button>
    <input
      type="number"
      class="form-control text-center"
      :value="modelValue"
      @input="onInput"
      @keyup.enter="emitChange"
      @blur="emitChange"
      v-min-value
      v-numeric
    />
    <button class="btn btn-outline-secondary border z-1 btn-lg" type="button" @click="handleAdd">
      <font-awesome-icon icon="fa-solid fa-plus" />
    </button>
  </div>
</template>

<script setup>
import { toRefs } from 'vue'

const props = defineProps({
  modelValue: {
    type: Number,
    required: true
  },
  id: {
    type: [String, Number],
    required: true
  }
})

const emit = defineEmits(['update:modelValue', 'add', 'subtract', 'change'])

const { modelValue, id } = toRefs(props)

// Solo los botones disparan evento al padre, NO cambian el valor local
function handleSubtract() {
    emit('subtract', id.value)
}

function handleAdd() {
  emit('add', id.value)
}

// El input directo sí puede modificar valor, pero después de emitir se resetea al prop
function onInput(event) {
  const newValue = Number(event.target.value)
  emit('update:modelValue', newValue)
}

function emitChange(event) {
  // Envía el valor final (input directo) al padre
  emit('change', id.value, Number(event?.target?.value ?? modelValue.value))
}
</script>

<style scoped lang="scss">
.quantity-selector {
  max-width: 300px;
  @media (min-width: 768px) {
    max-width: 100%;
  }
}
</style>
